import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home.jsx";

import Nav from "./Nav.jsx";
import About from "./components/About.jsx";
import Product from "./components/Product.jsx";
import IndustriesSection from "./components/IndustriesSection.jsx";
import Feature from "./components/ProductFeature.jsx"
import Facilities from "./components/Facilities.jsx";
import Testimonial from "./components/Testinomial.jsx";
import Contact from "./components/Contact.jsx";
import WhyChooseKSU from "./components/WhyChooseKSU.jsx";
import Homepage from "./components/Homepage.jsx";

function App() {
  return (
    <Router>
        <Nav/>
      <Routes>
        <Route path="/" element={<Homepage />} />
        {/* <Route path="/home" element={<Home />} /> */}
        <Route path="/about" element={<About />} />
        <Route path="/product" element={<Product />} />
        <Route path="/industry" element={<IndustriesSection />} />
        <Route path="/feature" element={<Feature />} />
        <Route path="/facility" element={<Facilities />} />
        <Route path="/testinomial" element={<Testimonial/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/whychooseksu" element={<WhyChooseKSU/>} />



      </Routes>
    </Router>
  );
}

export default App;
